document.addEventListener('DOMContentLoaded', function() {
            var slidesContainer = document.querySelector('.slides');
            var slides = document.querySelectorAll('.slide');
            var totalSlides = slides.length;
            var currentIndex = 0;
            var indicator = document.querySelector('.indicator');
            var trackWidth = document.querySelector('.indicator-track').offsetWidth;
            var slidesToShow = 4; // Default value
            var responsiveSettings = [
                { breakpoint: 991, slidesToShow: 2 },
                { breakpoint: 600, slidesToShow: 1 }
            ];

            function getSlidesToShow() {
                var width = window.innerWidth;
                for (var i = 0; i < responsiveSettings.length; i++) {
                    if (width <= responsiveSettings[i].breakpoint) {
                        return responsiveSettings[i].slidesToShow;
                    }
                }
                return slidesToShow;
            }

            function updateSliderSettings() {
                slidesToShow = getSlidesToShow();
                var slideWidthPercentage = 100 / slidesToShow;
                slides.forEach(function(slide) {
                    slide.style.minWidth = 24 + '%';
                });
                updateIndicatorWidth();
                updateSlider();
            }

            function updateIndicatorWidth() {
                var slideCount = totalSlides - slidesToShow;
                var indicatorWidth = 100 / (slideCount + 1);
                indicator.style.width = indicatorWidth + '%';
                updateIndicatorPosition();
            }

            function updateIndicatorPosition() {
                var slideCount = totalSlides - slidesToShow;
                var indicatorWidth = 100 / (slideCount + 1);
                maxPosition = 100 - indicatorWidth;
                var position = (currentIndex / ((slideCount+1) - 1)) * maxPosition;
                indicator.style.left = position + '%';
            }

               function updateSlider() {
        var width = window.innerWidth;
        var translateX;
        if (width <= 600) {  // Mobile
            translateX = -(currentIndex * (200 / slidesToShow));
        } else {  // Desktop
            translateX = -(currentIndex * (100 / slidesToShow));
        }
        slidesContainer.style.transform = 'translateX(' + translateX + '%)';
        updateIndicatorPosition();
        updateNavigationButtons();
    }

            function updateNavigationButtons() {
                document.getElementById('prev').style.display = currentIndex === 0 ? 'none' : 'block';
                document.getElementById('next').style.display = currentIndex === totalSlides - slidesToShow ? 'none' : 'block';
            }

            document.getElementById('next').addEventListener('click', function() {
                if (currentIndex < totalSlides - slidesToShow) {
                    currentIndex++;
                    updateSlider();
                }
            });

            document.getElementById('prev').addEventListener('click', function() {
                if (currentIndex > 0) {
                    currentIndex--;
                    updateSlider();
                }
            });

            window.addEventListener('resize', function() {
                updateSliderSettings();
            });

            updateSliderSettings();
        });